
const digest = '0a0dae0eaa0174c98cfca8965434b4630c6eed56709c0310514a3cd16149ce3f';
const classes = {"wrapper":"_wrapper_17u3p_1"};
const css = `._wrapper_17u3p_1 {
  font-family: Rubik, "sans-serif";
  width: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  